import http from "@/utils/http";

// 分页查询指定班级学生
export function getClassStudent(data) {
  return http({
    url: "/class/students" + data,
    method: "GET"
  });
}

// 添加新学生（创建学生账号）
export function addStudent(id, data) {
  return http({
    url: "/student/add?classid=" + id,
    method: "POST",
    data
  });
}

// 批量添加新学生（创建学生账号）
export function addStudents(id, data) {
  return http({
    url: "/student/add/batch?classid=" + id,
    method: "POST",
    data
  });
}

// 激活学员
export function onStu(id) {
  return http({
    url: "/student/active?studentid=" + id,
    method: "POST"
  });
}

// 暂停学员
export function offStu(id) {
  return http({
    url: "/student/frozen?studentid=" + id,
    method: "POST"
  });
}

// 移除学生
export function removeStu(data) {
  return http({
    url: "/class/student/moveout",
    method: "POST",
    data
  });
}

// 批量移除学生
export function removeStus(data) {
  return http({
    url: "/class/students/moveout",
    method: "POST",
    data
  });
}

// 分页查询机构所有学生
export function selectStu(data) {
  return http({
    url: "/user/students",
    method: "GET",
    params: data,
  });
}

// 将已有学生添加到班级
export function addStuToClass(data) {
  return http({
    url: "/class/student/add",
    method: "POST",
    data
  });
}

// 将已有学生添加到班级【批量添加】
export function addStusToClass(data) {
  return http({
    url: "/class/students/add",
    method: "POST",
    data
  });
}

// 删除学生
export function delStu(data) {
  return http({
    url: "/student/delete?studentid=" + data,
    method: "POST"
  });
}

// 删除学生【批量添加】
export function delStus(data) {
  return http({
    url: "/students/delete",
    method: "POST",
    data
  });
}
